import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from "vue";
  import InputSearch from "@/components/ui/input/InputSearch.vue";
  import { EstateInterface } from "@/types/EstateInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderWithEstateLogo',
  props: {
    estate: {
      type: Object as PropType<EstateInterface>,
      default: null,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props, PropType, ref, InputSearch, get EstateInterface() { return EstateInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})